import { Button, Row, Typography, useTheme } from "@commonlibs";
import clsx from "clsx";
import { Link } from "react-router-dom";
import { LinkIcon } from "ui/common/icons";
import ExternalLink from "../ExternalLink/ExternalLink";
import { ButtonLinkProps, ButtonLinkTarget } from "./ButtonLink.types";

function ButtonLink<T extends ButtonLinkTarget = "self">({
    className: classNameProp,
    target = "self" as T,
    to,
    variant = "primary",
    fullWidth,
    style,
    label,
    Icon = LinkIcon,
    ...rest
}: ButtonLinkProps<T>) {
    const { spacing } = useTheme();

    const commonProps = {
        style,
        className: clsx("button-link", classNameProp),
        children: (
            <Button variant={variant} fullWidth={fullWidth}>
                <Row gap={spacing["4.5"]} alignItems="center" css={{ height: "100%" }}>
                    {Icon && <Icon fontSize="1.5rem" />}
                    <Typography variant="body2Strong">{label}</Typography>
                </Row>
            </Button>
        ),
    };

    return target === "self" ? <Link to={to} {...commonProps} {...rest} /> : <ExternalLink href={to} {...commonProps} />;
}

export default ButtonLink;
